import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Favorites from '../interfaces/favorites.interface';
import Frame from '../interfaces/frame.interface';

import RootState from '../interfaces/root.interface';

const initialState: Favorites = {
  favorites: []
};
const favoriteSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    addFavorites: (state, action: PayloadAction<Frame>) => {
      const favorites = state.favorites;

      return {
        ...state,
        favorites: [...favorites, action.payload],
      };
    },
    removeFavorite: (state, action: PayloadAction<any>) => {
      const orderIndex = action.payload;
    
      const favorites = [
        ...state.favorites.slice(0, orderIndex),
        ...state.favorites.slice(orderIndex + 1),
      ];
      
      return {
        ...state,
        favorites
      };
    },
  }
});

export const getFavorites = (state: RootState) => state.favorites;
export default favoriteSlice;
